import { IExamen } from '../../../database/models/IExamen.model';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Injectable } from '@angular/core';
import { DatabaseService } from '../../../database/database.service';
import { formatDate } from '@angular/common';
import { BackgroundSyncService } from '../../..//helpers/backgroundSync.service';

@Injectable({
  providedIn: 'root',
})
export class ExamsService {

  constructor(
    private http: HttpClient,
    private backgroundSyncService: BackgroundSyncService,
    private databaseService: DatabaseService
  ) { }

  getCurrentUserUserId(): number {
    return JSON.parse(sessionStorage.getItem('currentUser')).userId;
  }

  getCurrentUserModelId(): number {
    return JSON.parse(sessionStorage.getItem('currentUser')).modelId;
  }

  getCurrentUserModelName(): string {
    return JSON.parse(sessionStorage.getItem('currentUser')).modelName;
  }

  getExamenesPeriodicos(): Observable<any> {
    const examenesUrl = this.buildUrlApi('estudios/periodic');
    const request = {
      modelId: this.getCurrentUserModelId(),
    };
    return this.http.post<any[]>(examenesUrl, request, { observe: 'response' });
  }

  getTiposCaracterizacionSemiologica(): Observable<any> {
    const tiposCaracterizacionSemiologica = this.buildUrlApiMasterTables(
      'tiposCaracterizacionSemiologica'
    );
    return this.http.get<any>(tiposCaracterizacionSemiologica);
  }

  /**
   * Método encargado de consultar al API los examenes periodicos filtrados
   */
  getExamenesPeriodicosFiltrados(data?: any): Observable<any> {
    const examenesUrl = this.buildUrlApi('estudios/periodic');
    var request = {
      modelId: this.getCurrentUserModelId(),
      filtros: [],
    };

    if(data.labelVigencia.includes("Menor a 30 días")){
      request = this.addFilterToRequest("vigenciaMenor30", true, request);
    }
    if(data.labelVigencia.includes("De 31 a 45 días")){
      request = this.addFilterToRequest("vigencia31A45", true, request);
    }
    if(data.labelVigencia.includes("De 46 a 90 días")){
      request = this.addFilterToRequest("vigencia46A90", true, request);
    }
    if(data.labelVigencia.includes("Mayor a 91 días")){
      request = this.addFilterToRequest("vigenciaMayor91", true, request);
    }
    request = this.addFilterToRequest("tipoEstudioCod", data?.tipoEstudio, request);
    request = this.addFilterToRequest("numeroLote", data?.numeroLote, request);
    request = this.addFilterToRequest("numeroCarpeta", data?.numeroCarpeta, request);
    request = this.addFilterToRequest("tipoDocumentoTrabajador", data?.tipoDocumentoTrabajador, request);
    request = this.addFilterToRequest("nroDocumentoTrabajador", data?.nroDocumentoTrabajador, request);
    
    return this.http.post<any[]>(examenesUrl, request, { observe: 'response' });
  }

  /**
   * Método encargado de consultar al API los examenes de reevaluacion
   */
  getExamenesReevaluacion(): Observable<any> {
    const examenesUrl = this.buildUrlApi('estudios/recalificacion');
    const request = {
      modelId: this.getCurrentUserModelId(),
    };
    return this.http.post<any[]>(examenesUrl, request, { observe: 'response' });
  }

  /**
   * Método encargado de consultar al API los examenes de reevaluacion filtrados
   */
   getExamenesReevaluacionFiltrados(data : any): Observable<any> {
    const examenesUrl = this.buildUrlApi('estudios/recalificacion');
    var request = {
      modelId: this.getCurrentUserModelId(),
      filtros: [],
    };

    if(data.labelVigencia.includes("Menor a 12 días")){
      request = this.addFilterToRequest("vigenciaMenor12", true, request);
    }
    if(data.labelVigencia.includes("De 12 a 20 días")){
      request = this.addFilterToRequest("vigencia12A20", true, request);
    }
    if(data.labelVigencia.includes("De 21 a 30 días")){
      request = this.addFilterToRequest("vigencia21A30", true, request);
    }
    if(data.labelVigencia.includes("Mayor a 31 días")){
      request = this.addFilterToRequest("vigenciaMayor31", true, request);
    }
    request = this.addFilterToRequest("tipoEstudioCod", data?.tipoEstudio, request);
    request = this.addFilterToRequest("numeroLote", data?.numeroLote, request);
    request = this.addFilterToRequest("numeroCarpeta", data?.numeroCarpeta, request);
    request = this.addFilterToRequest("tipoDocumentoTrabajador", data?.tipoDocumentoTrabajador, request);
    request = this.addFilterToRequest("nroDocumentoTrabajador", data?.nroDocumentoTrabajador, request);

    return this.http.post<any[]>(examenesUrl, request, { observe: 'response' });
  }

  /**
   * * Método encargado de consultar al API los examenes cargados
   */
  getExamenesCargados(data?: any): Observable<any> {
    const examenesUrl = this.buildUrlApi('estudios/loaded');
    var request = {
      modelId: this.getCurrentUserModelId(),
      filtros:[],
    };

    request = this.addFilterToRequest("cuit", data?.empresaCuit, request);
    request = this.addFilterToRequest("empresa", data?.empresaRazonSocial, request);
    request = this.addFilterToRequest("numeroLote", data?.numeroLote, request);
    request = this.addFilterToRequest("tipoDocumentoTrabajador", data?.tipoDocumentoTrabajador, request);
    request = this.addFilterToRequest("nroDocumentoTrabajador", data?.nroDocumentoTrabajador, request);
    request = this.addFilterToRequest("tipoEstudioCod", data?.nombreExamen, request);
    request = this.addFilterToRequest("periodico", data?.tipoExamen != null ? (data.tipoExamen === "Periódico" ? "true" : "false") : null, request);
    request = this.addFilterToRequest("tipoDictamen", data?.tipoDictamen, request);
    request = this.addFilterToRequest("numeroCarpeta", data?.numeroCarpeta, request);

    return this.http.post<any[]>(examenesUrl, request, { observe: 'response' });
  }

  addFilterToRequest(campo: any, valor: any, request: any): any{
    if( null !== valor){
      request.filtros.push(
        {
          campo: campo,
          valor: String(valor),
        }
      );
    }

    return request;
  }

  /**
   * Método encargado de obtener los tipos de dictamen desde el API
   */
  getTiposDictamen(): Observable<any> {
    const tiposDictamen = this.buildUrlApiMasterTables('tiposDictamen');
    return this.http.get<any>(tiposDictamen);
  }

  // MOTIVOS CIERRE
  getMotivosCierre(): Observable<any> {
    const motivosCierreUrl = this.buildUrlApiMasterTables('motivosCierre');
    return this.http.get<any[]>(motivosCierreUrl);
  }

  //* NOMBRE EXAMEN
  getNombresEstudios(): Observable<any> {
    const nombresEstudios = this.buildUrlApiMasterTables('nombresEstudios');
    return this.http.get<any>(nombresEstudios);
  }

  //* TIPOS DE DOCUMENTO
  getTiposDocumento(): Observable<any> {
    const tiposDocumento = this.buildUrlApiMasterTables('tiposDocumento');
    return this.http.get<any>(tiposDocumento);
  }

  //* TIPOS EXAME
  getTiposExamen(): any {
    const tiposExamen = [
      {
        tipoExamen: 1,
        descripcion: "Periódico",
    },
    {
        tipoExamen: 2,
        descripcion: "Reconfirmación",
    }];

    return tiposExamen;
  }

  // ESPECIALIDADES
  getEspecialidades(): Observable<any> {
    const especialidadesUrl = this.buildUrlApiMasterTables('especialidades');
    return this.http.get<any[]>(especialidadesUrl);
  }

  async closeExam(examenData, motivoCierre): Promise<any> {
    examenData.motivoCierre = motivoCierre?.codigo;
    const isOnline = await (
      await this.databaseService.getOnlineStatusFromOfflineDB()
    ).isStillOnline;
    if (isOnline) {
      return this.closeExamPeriodicApi(this.buildExamenDataToSend(examenData));
    } else {
      return this.closeExamPeriodicOffline(examenData);
    }
  }

  async cancelAbsenceExam(examenData): Promise<any> {
    const isOnline = await (
      await this.databaseService.getOnlineStatusFromOfflineDB()
    ).isStillOnline;
    if (isOnline) {
      return this.cancelAbsenceExamPeriodicApi(this.buildExamenDataToSend(examenData));
    }
  }

  public buildObjetPorEnviar(obj: any): any {
    const returnObj: any = {
      id: obj.examenData.id,
      tipoEstudio: obj.examenData.tipoEstudio,
      fechaAsignacion: obj.examenData.fechaAsignacion,
      lote: obj.examenData.lote,
      esops: obj.examenData.esops,
      trabajador: obj.examenData.trabajador,
      vigenciaColor: obj.examenData.vigenciaColor,
      numeroCarpeta: obj.examenData.numeroCarpeta,
      labelExamen: obj.labelExamen,
      provinciaNombreEstudio: obj.examenData.provinciaNombreEstudio,
      datosPorEnviar: {
        examenDataToSend: obj.examenDataToSend,
        fueCerrado: obj.fueCerrado,
        onOnlineSendTo: obj.onOnlineSendTo,
        labelExamen: obj.labelExamen,
        error: obj.error,
        errorMessage: obj.errorMessage,
      },
    };
    if (
      returnObj.datosPorEnviar !== null &&
      returnObj.datosPorEnviar.fueCerrado === true
    ) {
      returnObj.datosPorEnviar.labelCerrado = 'Cerrado';
    }
    return returnObj;
  }

  private buildUrlApi(method: string): string {
    return `${environment.apiUrl}` + method;
  }

  private buildUrlApiMasterTables(method: string): string {
    return `${environment.apiUrl}` + 'masterTables/' + method;
  }

  private closeExamPeriodicApi(objeto: any): Promise<any> {
    return this.http
      .post<any>(this.buildUrlApi('estudios/ausente'), objeto)
      .toPromise();
  }

  private cancelAbsenceExamPeriodicApi(objeto: any): Promise<any> {
    return this.http
      .post<any>(this.buildUrlApi('estudios/anularAusente'), objeto)
      .toPromise();
  }

  private async closeExamPeriodicOffline(examenData: IExamen): Promise<any> {
    try {
      const dataToSend = this.buildExamenDataToSend(examenData);
      await this.databaseService.setExamenOnPresentismoPorEnviarTable(
        dataToSend,
        this.buildUrlApi('estudios/ausente')
      );
      
    
      examenData.asistencia = 'Ausente';
      examenData.motivoCierre = dataToSend.motivo;
      
      const tabla = `examenes${examenData.lote.reevaluacion ? 'Reevaluacion' : 'Periodicos'}`;
      this.databaseService.editTableItem(examenData.id, tabla, examenData);
      this.databaseService.editTableItem(examenData.id, tabla + 'Filtrados', examenData);
      
      this.backgroundSyncService.registerEvent('close-examen');
      return { offline: true, obj: dataToSend };
    } catch (error) {
      throw new Error('false');
    }
  }

  private async cancelAbsenceExamPeriodicOffline(examenData: IExamen): Promise<any> {
    try {
      const dataToSend = this.buildExamenDataToSend(examenData);
      await this.databaseService.setExamenOnPresentismoPorEnviarTable(
        dataToSend,
        this.buildUrlApi('estudios/anularAusente')
      );
      
      examenData.asistencia = null;
      examenData.motivoCierre = null;
      
      const tabla = `examenes${examenData.lote.reevaluacion ? 'Reevaluacion' : 'Periodicos'}`;
      this.databaseService.editTableItem(examenData.id, tabla, examenData);
      this.databaseService.editTableItem(examenData.id, tabla + 'Filtrados', examenData);
      
      this.backgroundSyncService.registerEvent('cancel-absence-examen');
      return { offline: true, obj: dataToSend };
    } catch (error) {
      throw new Error('false');
    }
  }

  private buildExamenDataToSend(examenData: any): any {
    return {
      userId: this.getCurrentUserUserId(),
      modelId: this.getCurrentUserModelId(),
      examenNumero: examenData.id,
      username: this.getCurrentUserModelName(),
      motivo: examenData.motivoCierre,
      fechaCierre: formatDate(new Date(), 'yyyy-MM-dd', 'en'),
    };
  }
}
